/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Stbody1Inputs */

const zh_landing_admin_stbody1 = /** @type {(inputs: Landing_Admin_Stbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从个性化学习路径到进度跟踪，StudyOS 会适应每位学习者的节奏与风格。记录表现、培养学习习惯，并提醒接下来要复习什么。多端同步，让学习随时随地发生。`)
};

const en_landing_admin_stbody1 = /** @type {(inputs: Landing_Admin_Stbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From personalized learning paths to progress tracking, StudyOS adapts to each learner's pace and style. Track performance, build study streaks, and get reminders on what to review next. Everything stays in sync across devices — so learning happens anywhere, anytime.`)
};

const es_landing_admin_stbody1 = /** @type {(inputs: Landing_Admin_Stbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde rutas de aprendizaje personalizadas hasta el seguimiento del progreso, StudyOS se adapta al ritmo y estilo de cada estudiante. Registra el rendimiento, crea rachas de estudio y envía recordatorios sobre qué repasar. Todo se sincroniza entre dispositivos, para que aprender ocurra en cualquier lugar y momento.`)
};

/**
* | output |
* | --- |
* | "From personalized learning paths to progress tracking, StudyOS adapts to each learner's pace and style. Track performance, build study streaks, and get remin..." |
*
* @param {Landing_Admin_Stbody1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_stbody1 = /** @type {((inputs?: Landing_Admin_Stbody1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Stbody1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_stbody1(inputs)
	if (locale === "en") return en_landing_admin_stbody1(inputs)
	return es_landing_admin_stbody1(inputs)
});
export { landing_admin_stbody1 as "landing_admin_stBody" }